import { render, staticRenderFns } from "./Qyzzdqtx.vue?vue&type=template&id=25ae9f5d&scoped=true&"
import script from "./Qyzzdqtx.vue?vue&type=script&lang=js&"
export * from "./Qyzzdqtx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae9f5d",
  null
  
)

export default component.exports